///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import Accordion from "../form-controls/Accordion";
import Strategy from "../new-bid/Strategy";
import { mode, modeType } from "../../helpers/types";
import messages from "../../helpers/messages";

function BidStrategy({
  bid,
  setModeDetails,
  validationData,
  removeError,
  userDivision,
  validateStrategicQuantile
}) {
  const { featureFlags: { crmEnableImdlUi } } = useSelector(state => state);
  const modes = bid.modes;

  return (
    <Fragment>
      {modes.map(modeDetails => (
        <Fragment key={modeDetails.mode}>
          {modeDetails.mode === mode.tl && (
            <Accordion title={messages.truckload.defaultMessage}>
              <Strategy
                type={modeType.tl}
                modeDetails={modeDetails}
                setModeDetails={setModeDetails}
                validationData={validationData.tl}
                removeError={removeError}
                bidType={bid.bidType}
                userOrBidDivision={userDivision}
                validateStrategicQuantile={validateStrategicQuantile}
                bidScac={bid.bidScac}
                isReview={false}
              />
            </Accordion>
          )}
          {modeDetails.mode === mode.ltl && (
            <Accordion title={messages.lessThanTruckload.defaultMessage}>
              <Strategy
                type={modeType.ltl}
                modeDetails={modeDetails}
                setModeDetails={setModeDetails}
                validationData={validationData.ltl}
                removeError={removeError}
                bidScac={bid.bidScac}
                isReview={false}
              />
            </Accordion>
          )}
          {!crmEnableImdlUi && modeDetails.mode === mode.imdl && (
            <Accordion title={messages.intermodal.defaultMessage}>
              <Strategy
                type={modeType.imdl}
                modeDetails={modeDetails}
                setModeDetails={setModeDetails}
                validationData={validationData.imdl}
                removeError={removeError}
                bidScac={bid.bidScac}
                isReview={false}
              />
            </Accordion>
          )}
        </Fragment>
      ))}
    </Fragment>
  );
}

export default BidStrategy;
